import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';

export function usePinConversation() {
  const queryClient = useQueryClient();

  const {
    mutate,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<{ data: unknown }, Error, { id: string; pinned: boolean }>({
    mutationFn: ({ id, pinned }) => api.put(`conversations/${id}/pin`, { pinned }),
    onError: pinError =>
      notifyAndLogError(
        'Could not update chat',
        'The chat could not be updated. Please try again.',
        pinError,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
    },
  });

  const setPinned = (id: string, pinned: boolean) => mutate({ id, pinned });

  return { setPinned, error, isLoading, reset };
}
